module.exports = __webpack_public_path__ + "img/c036347.png";